import Helpers from "commons/helpers";
import Constants from "constants/index";
import ProfileService from "services/identity/profile.service";

import { call, put, takeLatest } from "redux-saga/effects";
import { IUserInfo, IUserAuthorization } from "commons/interfaces";
import { UserState, fetchUser, fetchUserFailed, fetchUserSuccess } from "store/slice/user.slice";

const profileService = new ProfileService();

function* fetchingUser() {
    try {

        let workingOrganization = Helpers.getItemInLocalStorage(Constants.StorageKeys.ORGANIZATION_ID, "") as string;

        const userInfo: IUserInfo = yield call(profileService.getUserInfo);

        const userAuthorization: IUserAuthorization = yield call(
            profileService.getUserAuthorization,
            (workingOrganization === "0") ? undefined : workingOrganization
        );

        const arrResourceURI = [
            Constants.MenuResourceURI.REPORT,
            Constants.MenuResourceURI.SETTING,
            Constants.MenuResourceURI.STATISTIC,
            Constants.MenuResourceURI.SYNTHETIC,
            Constants.MenuResourceURI.MONITORING,
        ];

        const itemFirst = [...userAuthorization?.menuDetails || []].find(e => arrResourceURI.includes(e.resourceURI));
        if (itemFirst) {
            const itemFirstChild = [...userAuthorization?.menuDetails || []].find(e => (e.parentMenu === itemFirst.id));
            Helpers.setItemInLocalStorage(Constants.StorageKeys.FIRST_URL, itemFirstChild?.externalUrl || "");
        };

        const organizationLogoUrl = userInfo?.currentServiceOrganizations?.find(o => o.id === workingOrganization)?.logoUrl;

        const result: UserState = {
            userInfo: userInfo,
            userAuthorization: userAuthorization,
            workingOrganization: workingOrganization,
            accessible: userAuthorization.accessible,
            organizationLogoUrl
        };

        yield put(fetchUserSuccess(result));
    } catch (error) {
        const err = Helpers.handleExceptionError(error);
        yield put(fetchUserFailed(err));
    }
}

export default function* userInfoSaga() {
    yield takeLatest(fetchUser().type, fetchingUser);
}
